import React from 'react'
import styles from 'components/Shared/Chip/Chip.module.css'
import { ReactComponent as DeleteIcon } from 'assets/icons/exit.svg'
import { Chip as MaterialChip } from '@material-ui/core'

export function Chip ({ label, onClick, onDelete  }) {
  return (
    <MaterialChip
      className={styles.chip}
      onClick={onClick}
      deleteIcon={onDelete && <DeleteIcon className={styles.deleteIcon}/>}
      onDelete={onDelete}
      label={label}
    />
  )
}
